import { ref } from 'vue';

const isOpen = ref(false);

export default function useContactModal() {
  const openContactModal = () => {
    isOpen.value = true;
  };

  const closeContactModal = () => {
    isOpen.value = false;
  };

  return {
    isOpen,
    openContactModal,
    closeContactModal,
  };
}
